import {
  SET_PENDING,
  SET_TOUCHED,
  SET_RECEIVING_SITES,
  FORGET_RECEIVING_SITES,
} from "./types";
import { Auth, Firestore } from "config";
const snapOptions = { includeMetadataChanges: true };
const findDocIndex = (array, id) =>
  array.findIndex((item) => item.DocId === id);

const receivingSiteList = [];
const receivingSiteRef = {};
let receivingSiteUnsubscribe = null;
export const acGetReceivingSites = (dispatch, getState) => {
  // Used to prevent additional executions; This AC should only run when touched property is false;
  dispatch({ type: SET_TOUCHED, payload: true });

  // Use Auth listener to prevent unauthorized access from non-users; Also clears data when user logs off;
  Auth.onAuthStateChanged((user) => {
    if (user) {
      const collectionRef = Firestore.collection("receiving-sites");
      const handleSnap = (snap) => {
        const docChangeSize = snap.docChanges().length;
        const isPending = getState().receivingSites.pending;

        // If collection is empty and redux state is pending, then set pending to false to show first snap performed
        if (docChangeSize === 0 && isPending)
          dispatch({ type: SET_PENDING, payload: false });
        // If 1 or more doc change in snap, then loop through changes and dispatch to redux state
        else if (docChangeSize >= 1) {
          for (let i = 0; i < docChangeSize; i++) {
            const { type, doc } = snap.docChanges()[i];
            const docData = {
              ...doc.data(),
              DocId: doc.id,
              ReceivingSiteId: doc.id,
            };
            if (type === "added") receivingSiteList.push(docData);
            if (type === "modified")
              receivingSiteList.splice(
                findDocIndex(receivingSiteList, doc.id),
                1,
                docData
              );
            if (type === "removed")
              receivingSiteList.splice(
                findDocIndex(receivingSiteList, doc.id),
                1
              );
            receivingSiteRef[doc.id] = docData;
          }
          const receivingSites = {
            all: [...receivingSiteList],
            active: receivingSiteList.filter((item) => item.Active),
            inactive: receivingSiteList.filter((item) => !item.Active),
            ref: receivingSiteRef,
          };
          dispatch({ type: SET_RECEIVING_SITES, payload: receivingSites });
          dispatch({ type: SET_PENDING, payload: false });
        }
      };
      const handleError = (error) =>
        console.log("acGetReceivingSites Error: ", error.message, { error });
      receivingSiteUnsubscribe = collectionRef.onSnapshot(
        snapOptions,
        handleSnap,
        handleError
      );
    } else {
      dispatch({ type: FORGET_RECEIVING_SITES });
      if (receivingSiteUnsubscribe) receivingSiteUnsubscribe();
    }
  });
};
